import {
  adminAiCoverageSchema,
  adminAiMemorySchema,
  adminAiUsageSchema,
  type AdminAiCoverage,
  type AdminAiMemory,
  type AdminAiUsage,
} from '@steado/admin-contract/ai-ops';
import { queryOptions } from '@tanstack/react-query';

import type { ApiClient } from '@/lib/api/client';

/**
 * Three aggregates, three queries, deliberately not one endpoint.
 *
 * They read different tables and fail independently: Redis being down should
 * cost the memory panel its queue counts, not take the spend table with it.
 */

export function aiUsageQueryOptions(api: ApiClient, days: number) {
  return queryOptions({
    queryKey: ['admin', 'ai-usage', days],
    queryFn: (): Promise<AdminAiUsage> =>
      api.request({ path: '/admin/ai/usage', query: { days }, schema: adminAiUsageSchema }),
    placeholderData: (previous) => previous,
  });
}

export function aiCoverageQueryOptions(api: ApiClient, days: number) {
  return queryOptions({
    queryKey: ['admin', 'ai-coverage', days],
    queryFn: (): Promise<AdminAiCoverage> =>
      api.request({ path: '/admin/ai/coverage', query: { days }, schema: adminAiCoverageSchema }),
    placeholderData: (previous) => previous,
  });
}

export function aiMemoryQueryOptions(api: ApiClient, days: number) {
  return queryOptions({
    queryKey: ['admin', 'ai-memory', days],
    queryFn: (): Promise<AdminAiMemory> =>
      api.request({ path: '/admin/ai/memory', query: { days }, schema: adminAiMemorySchema }),
    placeholderData: (previous) => previous,
  });
}
